import { Box, Typography } from '@mui/material'
import { Dismiss20Regular, PlugConnected20Regular } from '@/components/Icon'
import styles from './customModelDialog.module.scss'

export default function CustomModelHeader({ onClose }) {
  return (
    <Box className={styles.header}>
      <span className={styles.badge}>
        <PlugConnected20Regular aria-hidden />
      </span>
      <Box>
        <Typography component="h2" id="custom-model-title" className={styles.title}>
          Custom model
        </Typography>
        <Typography component="p" id="custom-model-subtitle" className={styles.subtitle}>
          Use your own provider account. Choose a provider, pick a model, and add your API key.
        </Typography>
      </Box>
      <button type="button" className={styles.closeButton} aria-label="Close" onClick={onClose}>
        <Dismiss20Regular aria-hidden />
      </button>
    </Box>
  )
}
